export default __webpack_public_path__ + "static/media/flyer.55fe667b.jpg";